import React from 'react';
import {
  HStack,
  Text,
  Box,
  Pressable,
} from '@gluestack-ui/themed';

interface ModuleItemProps {
  moduleTitle: string;
  pendingEvaluationsCount?: number;
  includesOverdues?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  triggerProps: any;
}

const ModuleItem: React.FC<ModuleItemProps> = ({
  moduleTitle,
  pendingEvaluationsCount = 0,
  includesOverdues = false,
  triggerProps,
}) => {
  const hasPending = pendingEvaluationsCount > 0;

  return (
    <Pressable
      {...triggerProps}
      p="$2"
      px="$3"
      mx="$2"
      my="$0.5"
      borderRadius="$md"
      $hover={{ bg: '$bgHover' }}
      testID={`module-item-${moduleTitle.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <HStack alignItems="center" space="md">
        <Text
          size="sm"
          color="$textBody"
          flex={1}
          numberOfLines={1}
        >
          {moduleTitle}
        </Text>
        {hasPending && (
          <Box
            bg={includesOverdues ? '$statusError' : '$brandBase'}
            borderRadius="$full"
            minWidth={20}
            height={20}
            px="$1.5"
            alignItems="center"
            justifyContent="center"
          >
            <Text size="2xs" fontWeight="bold" color="$textInverted">
              {pendingEvaluationsCount}
            </Text>
          </Box>
        )}
      </HStack>
    </Pressable>
  );
};

export default ModuleItem;
